// Generated at Mon Jan 19 13:39:42 CST 2026
export const environment = {
    production: true,
    hmr: false,
    apiUrl: 'https://vision-staging.jhtbrand.co',
};
